const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 30000,
};

export const geolocationErrorMessage = (error) => {
  if (error?.code === 1) return 'Permita o acesso à localização nas configurações do navegador.';
  if (error?.code === 2) return 'Não foi possível identificar sua localização neste dispositivo.';
  if (error?.code === 3) return 'A localização demorou para responder. Tente novamente em um local aberto.';
  return 'Não foi possível acessar a localização atual.';
};

export const getCurrentDeviceLocation = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error('Seu navegador não oferece acesso à localização.'));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    ({ coords }) => resolve({
      latitude: Number(coords.latitude.toFixed(6)),
      longitude: Number(coords.longitude.toFixed(6)),
      accuracy: Math.round(coords.accuracy || 0),
    }),
    reject,
    GEOLOCATION_OPTIONS
  );
});
